import {Component, OnInit} from '@angular/core';

@Component({
        selector: 'eil-pd',
        templateUrl: './pd.component.html',
        styleUrls: ['./pd.component.scss'],
        standalone: false
    }
)
export class PDComponent implements OnInit {

    // @Input() public inputExample:    string;

    // public publicExample:            string;
    // public anotherExample:           any;

    // private privateExample:          boolean;

    constructor() {

    }

    ngOnInit() {

    }

}
